import {
  FormControl,
  FormHelperText,
  FormLabel,
  InputLabel,
  Select as MaterialSelect,
  MenuItem,
  styled,
} from "@mui/material";
import { SelectProps } from ".";
import { Tooltip } from "../Tooltip";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";

const Select = ({
  data = [],
  label,
  fullWidth,
  helperText,
  placeholder,
  required,
  floatLabel,
  name,
  id,
  variant = "outlined",
  blockedOptionTooltipText,
  ...props
}: SelectProps) => {
  const renderValue = (selected: unknown) => {
    const placeholderText = placeholder || "";

    return (
      data.find((option) => option.value === selected)?.label || (
        <StyledPlaceholder>{placeholderText}</StyledPlaceholder>
      )
    );
  };

  return (
    <FormControl
      disabled={props.disabled}
      fullWidth={fullWidth}
      required={required}
    >
      {label && <FormLabel>{label}</FormLabel>}
      {floatLabel && <InputLabel>{floatLabel}</InputLabel>}
      <StyledSelect
        sx={{ marginTop: "0px !important" }}
        displayEmpty
        renderValue={renderValue}
        name={name}
        id={id}
        {...props}
        variant={variant === "borderless" ? "outlined" : variant}
        className={`variant-${variant} ${props.className ?? ""}`}
      >
        {data.map((item) => (
          <StyledMenuItem
            key={item.label}
            disabled={!item.isBlocked && item.disabled}
            value={item.value}
            className={item.isBlocked ? "blocked" : ""}
          >
            {item.label}
            {item.isBlocked && (
              <Tooltip
                title={
                  blockedOptionTooltipText &&
                  blockedOptionTooltipText(item.value)
                }
              >
                <LockOutlinedIcon className="select-option-blocked-icon" />
              </Tooltip>
            )}
          </StyledMenuItem>
        ))}
      </StyledSelect>
      {helperText && (
        <FormHelperText error={props.error}>{helperText}</FormHelperText>
      )}
    </FormControl>
  );
};

export default Select;

const StyledPlaceholder = styled("span")(({ theme }) => ({
  color: theme.tokens.colors.gray[6],
  fontFamily: theme.typography.fontFamily,
}));
const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  "&.blocked": {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    color: theme.tokens.colors.gray[6],

    ".select-option-blocked-icon": {
      margin: 0,
      fontSize: "1rem",
      pointerEvents: "auto",
    },
  },
}));
const StyledSelect = styled(MaterialSelect)(({ theme }) => ({
  "&.variant-borderless": {
    borderColor: "transparent",
    padding: `${theme.tokens.spacing.xs} ${theme.tokens.spacing.sm}`,

    color: theme.tokens.colors.gray[7],
    marginBottom: "8px",
    width: "100%",

    "&:hover": {
      backgroundColor: theme.tokens.colors.gray[3],
    },

    ".MuiSelect-select": {
      fontFamily: "Nunito",
      fontSize: "14px",
      fontWeight: theme.tokens.typography.weight.bold,
      lineHeight: "18px",
      paddingRight: "2rem",
    },
  },
}));
